const namespace = 'ag_grid.';

const translations = {
    searchOoo: `${namespace}search_ooo`,
};

export { translations };
